import { Controller } from 'stimulus'

import './component.scss'

window.Stimulus.register(
  'reformExampleCardSpDescription',
  class extends Controller {
    static targets = ['description', 'moreText']

    connect () {
      const descriptionHeight = this.descriptionTarget.scrollHeight
      const displayHeight = this.descriptionTarget.offsetHeight

      if (descriptionHeight <= displayHeight) {
        this.moreTextTarget.classList.add('is-hidden')
      }
    }
  }
)
